import React from "react";
import AppLayout from "../components/AppLayout";
import { ShieldCheck } from "lucide-react";

function Section({ title, children, isDark }) {
  return (
    <section
      className={`rounded-3xl border p-6 shadow-sm ${
        isDark ? "border-slate-800 bg-slate-900" : "border-slate-200 bg-white"
      }`}
    >
      <h2 className={`text-lg font-semibold ${isDark ? "text-white" : "text-slate-900"}`}>
        {title}
      </h2>
      <div className={`mt-3 space-y-3 text-sm leading-7 ${isDark ? "text-slate-300" : "text-slate-600"}`}>
        {children}
      </div>
    </section>
  );
}

export default function PrivacyPage({ isDark, setIsDark, currency, setCurrency }) {
  return (
    <AppLayout
      isDark={isDark}
      setIsDark={setIsDark}
      currency={currency}
      setCurrency={setCurrency}
      eyebrow="Legal"
      title="Privacy Policy"
      description="How SpaceM8 collects, uses, and protects platform information."
    >
      <div className="space-y-6">
        <div
          className={`rounded-3xl border p-5 shadow-sm ${
            isDark ? "border-slate-800 bg-slate-900" : "border-slate-200 bg-white"
          }`}
        >
          <div className="flex items-center gap-3 text-sky-700">
            <ShieldCheck className="h-5 w-5" />
            <span className="font-medium">Your data matters</span>
          </div>
          <p className={`mt-3 text-sm leading-7 ${isDark ? "text-slate-300" : "text-slate-600"}`}>
            SpaceM8 is designed to support property operations with strong attention to privacy, access control, and responsible platform usage.
          </p>
        </div>

        <Section title="Information we collect" isDark={isDark}>
          <p>We may collect account details, platform preferences, operational records, and communication history needed to run the service.</p>
          <p>This can include profile details, tenant records, property information, maintenance logs, invoices, and usage preferences.</p>
        </Section>

        <Section title="How information is used" isDark={isDark}>
          <p>Information is used to provide the platform, improve workflows, generate reports, support AI recommendations, and maintain service quality.</p>
          <p>We may also use data to personalize dashboards, settings, and operational alerts.</p>
        </Section>

        <Section title="Security and access" isDark={isDark}>
          <p>We use access controls, administrative permissions, and technical safeguards to reduce unauthorized access.</p>
          <p>Users are responsible for protecting their credentials and using the platform in line with internal governance policies.</p>
        </Section>

        <Section title="Retention and updates" isDark={isDark}>
          <p>Information may be retained for operational, compliance, and service continuity reasons.</p>
          <p>This policy may be updated over time as the product evolves.</p>
        </Section>
      </div>
    </AppLayout>
  );
}